import parse from 'html-react-parser';
import { useClientTranslation } from '../i18n';

export const parseText = (text: string) => parse(text.replace(/\n/g, '<br>'));

/** Replaces every case-insensitive occurrence of "jncquoi" with the brand's stylised casing. */
export const brandifyJncquoi = (text: string) => text.replace(/jncquoi/gi, 'JNcQUOI');

export function getTimeOfDayWord(): string {
  const translation = useClientTranslation();

  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return translation('App.Labels.Morning');
  if (hour >= 12 && hour < 18) return translation('App.Labels.Afternoon');
  if (hour >= 18 && hour < 21) return translation('App.Labels.Evening');
  return translation('App.Labels.Night');
}
